import { ModalComponent } from "@/pages/home/Components/Modal";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import styles from "./DetalhesModal.module.css";
import { leadApi } from "@/services/api/leads";
import { etapaJornadaOptions, Lead, useLeads } from "../context/leadContext";
import { CustomSnackbar } from "@/utils/alert";
import GoogleAdsIcon from "@/assets/iconsTable/google-ads-svgrepo-com.svg";
import LinkMeta from "@/assets/iconsTable/link1.svg";
import Meta from "@/assets/iconsTable/Meta.svg";
import { MuiTelInput } from "mui-tel-input";
import { delay } from "@/utils/delay";
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';

interface ModalProps {
  open: boolean;
  close: () => void;
  AttendantOption: Atendente[];
  selectedLead: DetalhesLead | null;
  atualizaLead?: () => void;
  local?: string;
}

type Severity = "success" | "error";

export interface Atendente {
  id: string;
  nome: string;
}

export interface DetalhesLead {
  id: string | number,
  nome?: string,
  telefone?: string,
  origem?: string,
  estagio?: string,
  estagio_id?: string,
  descricao?: string,
  atendenteId?: string,
  Atendente?: {
    nome?: string
  },
}

export function DetalhesModal({
  open,
  close,
  AttendantOption,
  selectedLead,
  local
}: ModalProps) {
  const { setLeads, setReloadList } = useLeads();
  const [apresentarAlerta, setApresentarAlerta] = useState(false);
  const [alertaInfo, setAlertaInfo] = useState({
    severity: "success" as Severity,
    message: "",
  });

  const [leadData, setLeadData] = useState({
    name: selectedLead?.nome || "",
    phone: selectedLead?.telefone || "",
    origin: selectedLead?.origem || "",
    stage: selectedLead?.estagio || "",
    stage_id: selectedLead?.estagio_id || "",
    description: selectedLead?.descricao || "",
    attendantId: selectedLead?.atendenteId || "",
    attendantName: selectedLead?.Atendente?.nome || "",
  });

  useEffect(() => {
    if (selectedLead) {
      setLeadData({
        name: selectedLead?.nome || "",
        phone: selectedLead?.telefone || "",
        origin: selectedLead?.origem || "",
        stage: selectedLead?.estagio || "",
        stage_id: selectedLead?.estagio_id || "",
        description: selectedLead?.descricao || "",
        attendantId: selectedLead?.atendenteId || "",
        attendantName: selectedLead?.Atendente?.nome || "",
      });
    }
  }, [selectedLead]);

  function lidarComOsCampos(e: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = e.target;
    setLeadData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  function lidarComCampoTelefone(value: string) {
    setLeadData((prevData) => ({
      ...prevData,
      phone: value,
    }));
  }

  function lidarComSelecionaAtendente(newAttendantName: string) {
    const selectedAttendant = AttendantOption.find(
      (attendant) => attendant.nome === newAttendantName
    );
    if (selectedAttendant) {
      setLeadData((prevData) => ({
        ...prevData,
        attendantId: selectedAttendant.id,
        attendantName: selectedAttendant.nome,
      }));
    }
  }

  async function salvar() {
    if (selectedLead) {
      const id = typeof selectedLead.id === 'number' ? selectedLead.id : parseInt(selectedLead.id as string, 10);
      const data = {
        name: leadData.name,
        phone: leadData.phone,
        origin: leadData.origin,
        stage: leadData.stage,
        stage_id: leadData.stage_id,
        description: leadData.description,
        attendantId: leadData.attendantId,
      };
      const response = await leadApi.updateLead(id, data);

      if (response.status === 200) {
        setLeads((prevLeads) =>
          prevLeads.map((lead) =>
            lead.id === id ? { ...lead, ...leadData } : lead
          )
        );

        setAlertaInfo({
          severity: "success",
          message: "Lead atualizado com sucesso",
        });
        setApresentarAlerta(true);
        delay(1500);
        setApresentarAlerta(false);
        setReloadList(true);
      } else {
        setAlertaInfo({
          severity: "error",
          message: "Erro ao atualizar lead",
        });
        setApresentarAlerta(true);
      }
    }
  }

  function lidarComFecharAlerta() {
    setApresentarAlerta(false);
  }

  function mostrarIcones() {
    if (leadData.origin === "ADS") {
      return (
        <div>
          <img
            src={GoogleAdsIcon}
            className="img-icon"
            alt="Google Ads"
          />
        </div>
      );
    } else if (leadData.origin === "LINK") {
      return (
        <div>
          <img
            src={LinkMeta}
            className="img-icon"
            alt="Link"
          />
        </div>
      );
    } else if (leadData.origin === "META") {
      return (
        <div>
          <img
            src={Meta}
            className="img-icon"
            alt="Meta"
          />
        </div>
      );
    }
  }

  return (
    <ModalComponent open={open} onClose={close}>
      <CustomSnackbar
        open={apresentarAlerta}
        severity={alertaInfo.severity}
        message={alertaInfo.message}
        handleClose={lidarComFecharAlerta}
      />

      <div className={styles.detalhes_lead_container}>
        <header className={styles.header_container}>
          <div className={styles.topo}>
            <h2>
              { local === 'Leads' ? 'Atualizar Lead' : 'Detalhes do Lead'}
            </h2>
          </div>

          <div className={styles.rodape}>
            <div className={styles.nome}>
              <h3>
                Lead:
              </h3>
              <h3>
                {leadData.name}
              </h3>
            </div>

            <div className={styles.origem}>
              <h3>Origem:</h3>
              {mostrarIcones()}
            </div>
          </div>

        </header>

        <main className={styles.main_container}>
          <form>
            <div className={styles.campos_atualizar_lead}>
              <TextField
                className={`${styles.campo_atuliazar_lead}`}
                fullWidth
                label='Stage_id'
                placeholder='Insira o título...'
                name='stage_id'
                value={leadData.stage_id}
                onChange={lidarComOsCampos}
                inputProps={{ maxLength: 150 }}
                InputLabelProps={{ shrink: !!leadData.stage_id }}
              />
              <FormControl
                fullWidth
                className={`${styles.campo_atuliazar_lead}`}
              >
                <InputLabel>Atendente</InputLabel>
                <Select
                  value={leadData.attendantName}
                  onChange={(e) => { lidarComSelecionaAtendente(e.target.value) }}
                  name='stage'
                  label='Atendente'
                  fullWidth
                >
                  {
                    AttendantOption.map((atendente) => (
                      <MenuItem key={atendente.id} value={atendente.nome}>
                        {atendente.nome}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </div>

            <div className={styles.campos_atualizar_lead}>
              <FormControl className={`${styles.campo_atuliazar_lead}`}>
                <InputLabel>Status</InputLabel>
                <Select
                  value={leadData.stage}
                  onChange={(event: SelectChangeEvent<string>) => {
                    const novoValor = event.target.value;
                    setLeadData((prevData) => ({
                      ...prevData,
                      stage: novoValor,
                    }));
                  }}
                  name='stage'
                  label='Status'
                  fullWidth
                >
                  {etapaJornadaOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <MuiTelInput
                label="Telefone do cliente"
                name="phone"
                fullWidth
                value={leadData.phone}
                onChange={(value) => { lidarComCampoTelefone(value) }}
              />
            </div>

            <TextField
              sx={{ width: '40rem' }}
              fullWidth
              label='Observação'
              placeholder='Insira a observação...'
              name='description'
              value={leadData.description}
              onChange={(lidarComOsCampos)}
              multiline
              rows={4}
            />

            <div className={styles.botoes}>
              <Button onClick={close}>
                <CloseIcon />
                Cancelar
              </Button>
              <Button onClick={salvar}>
                <RefreshIcon />
                Atualizar
              </Button>
            </div>
          </form>
        </main>
      </div>
    </ModalComponent>
  );
}